'use strict';

// make slider expand to height of largest slide
// by adding hidden spacer clone for each slide
app.directive('slide', function () {
  return {
    require: '^carousel',
    restrict: 'EA',
    link: function (scope, element, attrs, carouselCtrl, transclude) {
      transclude(function (clone) {
        var spacer = angular.element('<div class="spacer"></div>');
        spacer.append(clone);
        element.after(spacer);
      });
    }
  };
});
